import posed from 'react-pose';

export const FadeInDiv = posed.div({
  hidden: {
    opacity: 0,
    transition: {
      duration: 175,
      ease: 'easeIn',
    },
  },
  visible: {
    opacity: 0.75,
    transition: {
      ease: 'easeOut',
      duration: 150,
    },
  },
});
